<template>
    <div class="login-container">
        <el-form
            ref="rForm"
            :model="rForm"
            :rules="resetRules"
            class="login-form"
            auto-complete="on"
            label-position="left"
        >
            <!-- <p class="stystem_title">上海市书法家协会征稿系统</p> -->
            <div class="c-flex-ajcenter title_box">
                <h3 class="title">{{ $t('login.resetPwd') }}</h3>
                <LangSelect class="lang" />
            </div>
            <el-form-item prop="mobile">
                <el-input
                    v-model="rForm.mobile"
                    name="mobile"
                    type="text"
                    auto-complete="on"
                    :placeholder="$t('login.mobile')"
                    @input="bindKeyMobile"
                >
                    <i slot="prefix" class="el-icon el-icon-mobile-phone" />
                </el-input>
            </el-form-item>

            <el-form-item prop="new_password">
                <el-input
                    v-model="rForm.new_password"
                    :type="pwdType"
                    name="new_password"
                    autocomplete="on"
                    auto-complete="off"
                    :placeholder="$t('login.newPwd')"
                    @keyup.enter.native="submit"
                >
                    <i slot="prefix" class="el-icon el-icon-lock" />
                    <i slot="suffix" class="el-icon el-icon-view" :class="{'el-icon-view-actived':!pwdType}" @click="showPwd" />
                </el-input>
            </el-form-item>

            <el-form-item prop="new_password_confirmation">
                <el-input
                    v-model="rForm.new_password_confirmation"
                    :type="pwdType"
                    name="new_password_confirmation"
                    autocomplete="on"
                    auto-complete="off"
                    :placeholder="$t('login.confirmPwd')"
                    @keyup.enter.native="submit"
                >
                    <i slot="prefix" class="el-icon el-icon-lock" />
                    <i slot="suffix" class="el-icon el-icon-view" :class="{'el-icon-view-actived':!pwdType}" @click="showPwd" />
                </el-input>
            </el-form-item>

            <el-form-item prop="code">
                <div class="form-item">
                    <el-input
                        v-model="rForm.code"
                        name="code"
                        autocomplete="on"
                        auto-complete="off"
                        :placeholder="$t('login.verificationCode')"
                        clearable
                        style="width: 60%;"
                    />
                    <el-button size="small" type="primary" :class="{'disabledBtn':codeBtn}" @click="getCode">{{ codeName }}</el-button>
                </div>
            </el-form-item>

            <el-form-item>
                <el-button
                    class="login-btn"
                    :loading="loading"
                    size="medium"
                    type="primary"
                    style="width:100%;"
                    @click.native.prevent="submit"
                >{{ $t('login.resetPwd') }}</el-button>
            </el-form-item>
            <div class="other">
                <p @click="hancleChangeType('login')">{{ $t('login.loginIn') }}</p>
                |
                <p @click="hancleChangeType('register')">{{ $t('login.registerIn') }}</p>
                <!-- |
                <p @click="hancleChangeType('password')">修改密码</p> -->
            </div>
        </el-form>
    </div>
</template>

<script>
import LangSelect from '@/components/LangSelect'
import mix_user from '../mix_user'

export default {
    name: 'ResetPassword',
    components: { LangSelect },
    mixins: [mix_user],
    data() {
        return {
            rForm: {
                mobile: '',
                code: '',
                new_password: '',
                new_password_confirmation: ''
            }
        }
    },
    methods: {
        submit() {
            this.$refs['rForm'].validate((valid) => {
                if (valid) {
                    this.$emit('submit', this.rForm)
                }
            })
        }
    }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
@import '../../../styles/login';
@import '../../../styles/variables';
.login-container {
  position: fixed;
  height: 100%;
  width: 100%;
  background: url('../../../assets/images/bg.png') no-repeat;
  background-size: 100% 100%;

  .login-form {

    .form-item{
      display: flex;
      justify-content: space-between;
      align-items: center;

      /deep/ .el-input--mini .el-input__inner{
        padding-left: 20px;
      }

      /deep/ .el-button{
        font-size: 14px;
        padding: 8px 20px;
        line-height: inherit;
        box-shadow: 2px 3px 10px 0px $white;
      }

      .disabledBtn{
        background: #ccc;
        border-color: #ccc;
      }
    }
  }
}
</style>
